import {API_URL, apiDelete} from '../api'

export const deleteLeagueApi = async (id: string) => {
    return await apiDelete(API_URL, `league/${id}`)
}
